import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatTooltipModule } from '@angular/material/tooltip';
import { Account, AccountStatus } from '@olv/ui-shared/models/account.interface';
import { SignalRService } from '@olv/ui-shared/services/signalr.service';

@Component({
  selector: 'app-account-card',
  standalone: true,
  imports: [MatTooltipModule],
  templateUrl: './account-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./account-card.component.scss'],
})
export class AccountCardComponent {
  @Input({ required: true }) account!: Account;
  @Input() variant: 'merchant' | 'default' = 'default';
  @Output() cardClick = new EventEmitter<Account>();

  private signalRService = inject(SignalRService);

  readonly AccountStatus = AccountStatus;

  onCardClick(): void {
    this.cardClick.emit(this.account);
  }

  get statusClass(): string {
    return this.account.status === AccountStatus.ACTIVE ? 'active' : 'inactive';
  }

  get cardClass(): string {
    const base = 'account-card';
    const inactive = this.account.status === AccountStatus.INACTIVE ? 'inactive' : '';
    return [base, inactive].filter(Boolean).join(' ');
  }

  get groupNames(): string {
    return this.account?.groups?.map((g) => g.name).join(' / ') || '';
  }

  get isOnline(): boolean {
    return this.signalRService.isUserOnline(this.account?.id);
  }
}
